import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import i18n from 'i18n-react';

const PremiumHotel = (props) => {
  const { id, bgImage, propertyName, flyToMarker, hotelInfo } = props;
  return (
    <div
      className="premiumDiv"
      id={id}
      style={{
        backgroundImage:
          'linear-gradient( rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15) ), url(' + bgImage + ')',
      }}
    >
      <span className="fa-layers fa-fw fa-2x markerCircle" onClick={flyToMarker}>
        <FontAwesomeIcon icon={['fas', 'circle']} className="circle" />
        <FontAwesomeIcon icon={['fas', 'map-marker-alt']} className="marker" />
      </span>
      <div className="premiumClick" onClick={hotelInfo} />
      <div className="premiumInfoDiv" onClick={hotelInfo}>
        <span className="premiumName"> {propertyName}</span> <br />
        <span className="moreInfo">{i18n.translate('directory.view')} &gt;</span>
      </div>
    </div>
  );
};

PremiumHotel.propTypes = {
  id: PropTypes.string,
  bgImage: PropTypes.string,
  propertyName: PropTypes.string,
  flyToMarker: PropTypes.func,
  hotelInfo: PropTypes.func,
};

PremiumHotel.defaultProps = {
  id: '',
  bgImage: '',
  propertyName: '',
  flyToMarker: () => {},
  hotelInfo: () => {},
};

export default PremiumHotel;
